import { Injectable, signal } from '@angular/core';
import { UserProfile } from '../models/userProfile.model';

@Injectable({
  providedIn: 'root',
})
export class UserStoreService {
  private _user = signal<UserProfile | null>(this.loadFromStorage());
  user = this._user.asReadonly();
  private oldPassword?: string;

  private loadFromStorage(): UserProfile | null {
    try {
      const json = localStorage.getItem('userProfile');
      return json ? JSON.parse(json) : null;
    } catch {
      return null;
    }
  }

  setUser(user: UserProfile) {
    this._user.set(user);
    localStorage.setItem('userProfile', JSON.stringify(user));
  }

  clearUser() {
    this._user.set(null);
    localStorage.removeItem('userProfile');
  }

  getUser(): UserProfile | null {
    return this._user();
  }

  isLoggedIn(): boolean {
    return this._user() !== null;
  }

  getUserId(): string | null {
    return this._user() ? this._user()!.id : null;
  }

  getFullName(): string | null {
    return this._user()
      ? `${this._user()!.fullName}`
      : null;
  }
  getUserName(): string | null {
    return this._user() ? this._user()!.fullName : null;
  }
  getUserEmail(): string | null {
    return this._user() ? this._user()!.email : null;
  }

  getOldPassword() {
    return this.oldPassword;
  }
  setOldPassword(password: string) {
    this.oldPassword = password;
  }

  getUserRole(): string | null {
    return this._user() ? this._user()!.roleName : null;
  }

}
